import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../common/data.service';
import { AppTokenHandler } from '../../common/app-token-handler';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialogModule } from '@angular/material/dialog';
import { Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AzureAuthService } from 'src/app/common/azure-auth.service';
import { LoginService } from 'src/app/common/login.service';
import { catchError, takeUntil } from 'rxjs/operators';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    referralURL: string;
    private azure_token: string = '';
    constructor(private appToken: AppTokenHandler, private gservice: DataService,
        private route: Router, private spinnerService: NgxSpinnerService,
        private _azureAuthService: AzureAuthService,
        private loginService: LoginService) { }

        private readonly _destroying$ = new Subject<void>();
        ngOnDestroy(): void {
            this._destroying$.next();
            this._destroying$.complete();
          }

    ngOnInit() {
        debugger;
        if (environment.isHostingAzure)
            this.acquireAzureToken();
          else
            this.GetUserDetails();
    }


    GetUserDetails() {
        debugger;

        if (this.appToken.getSessionToken().length <= 0) {
            this.spinnerService.show();
            this.gservice.Login().subscribe((data: any) => {
                if (data.IsAuthenticated) {
                    this.appToken.setSessionToken(data);
                    this.route.navigate(['/dashboard']);
                } else {
                    this.route.navigate(['/error/1']);
                }
            }, (error: Response) => {
                if (error.status <= 0) {
                    this.route.navigate(['/error/2']);
                } else if (error.status === 401) {
                    this.route.navigate(['/error/1']);
                } else {
                    this.route.navigate(['/error/2']);
                }
            }, () => {
                this.spinnerService.hide();
            });
        } else {
            this.route.navigate(['/dashboard']);
        }
    }

    async acquireAzureToken() {
        this._azureAuthService.handleQueryParameters()
          .pipe(
            takeUntil(this._destroying$),
            catchError(error => {
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (result) => {
              if (result) {
                this.azure_token = result;
                this.loginService.GetUserDetails(this.azure_token);
              }
            }
          });
      }
}
